import ProgressBase from "../ProgressBase";

export interface ProgressBarProps {
  maxItems: number;
  itemLength: number;
  isActive?: boolean;
  color?: "danger";
}

export default function VLProgressBar(props: ProgressBarProps) {
  const percent = (props.itemLength / props.maxItems) * 100;
  const strokeColor =
    props.color === "danger" ? "var(--bright-orange)" : undefined;
  return (
    <ProgressBase
      fillPercent={percent}
      strokeColor={strokeColor}
      isActive={props.isActive}
    />
  );
}
